import { addCircleIcon, userBlack } from '../../../../assets/hostedassets';
import styles from '../../GlobalSearch.module.scss';
import { GlobalSearchResult } from '../../useSearchResultFetcher';
import OfficeIcon from '../../../../assets/Svg/OfficeIcon';
import { ENTITY_PILL_LABEL } from '../../../MagicUpload/Utils/MagicUploadConstants';
import { classifyEntityCard } from '../../../../modules/Investor/Portfolio/components/AddToWatchlist/identifierUtils';

type AddNewPillProps = {
    result: GlobalSearchResult;
};

// A person-shaped card (sole-prop entity or pan-profile individual) gets the person icon + a
// chip; a company card gets the office icon and no chip. Keyed on the single entityCategory so
// the icon and the label never diverge.
const ENTITY_PILL_LABEL_BY_CATEGORY: Record<string, string> = {
    SOLE_PROPRIETOR: ENTITY_PILL_LABEL.SOLE_PROPRIETOR,
    INDIVIDUAL: ENTITY_PILL_LABEL.INDIVIDUAL,
};

const AddNewPill = ({ result }: AddNewPillProps) => {
    // Distinguishes two same-name person cards (sole-prop entity vs. pan-profile individual).
    const entityCategory = classifyEntityCard(result);
    const pillLabel = entityCategory ? ENTITY_PILL_LABEL_BY_CATEGORY[entityCategory] ?? null : null;
    const baseIcon = pillLabel ? userBlack : null;

    return (
        <div className={styles.AddNewPill}>
            <>
                {baseIcon ? (
                    <img src={baseIcon} alt="org" className={`${styles.PillIcon} ${styles.PillIconDefault}`} />
                ) : (
                    <OfficeIcon className={`${styles.PillIcon} ${styles.PillIconDefault}`} />
                )}
                <img src={addCircleIcon} alt={'add'} className={`${styles.PillIcon} ${styles.PillIconHover}`} />
            </>
            <span className={styles.OrgName}>{result.orgName}</span>
            {pillLabel && <span className={styles.EntityPillLabel}>{pillLabel}</span>}
        </div>
    );
};

export default AddNewPill;
